import { useTranslation } from "react-i18next";
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import type { ChangeEvent } from "react";

type BooleanRadioPickerProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export function BooleanRadioPicker({ value, onChange }: BooleanRadioPickerProps): JSX.Element {
  const { t: translate } = useTranslation();

  const handleInputChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>): void => {
    const parsedValue = value === "true" ? true : false;
    onChange(parsedValue);
  };

  return (
    <RadioGroup row value={value} onChange={handleInputChange}>
      <FormControlLabel
        value={true}
        control={<Radio />}
        label={translate("listingsMatch.booleanRadioPicker.yes")}
      />
      <FormControlLabel
        value={false}
        control={<Radio />}
        label={translate("listingsMatch.booleanRadioPicker.no")}
      />
    </RadioGroup>
  );
}
